import { NQErrorCode } from "@visonum/network-quality-sdk";

export const errorCodeToString = (code: NQErrorCode): string => {
    switch (code) {
        case NQErrorCode.Server: return "Server";
        case NQErrorCode.Client: return "Client";
        case NQErrorCode.Connectivity: return "Connectivity";
        case NQErrorCode.SystemUnderMaintenance: return "SystemUnderMaintenance";
        case NQErrorCode.RateLimit: return "RateLimit";
        case NQErrorCode.ParallelSpeedtests: return "ParallelSpeedtests";
    }
}

export default errorCodeToString;